module.exports = "/assets/data/2e8a08f9f74b32368932fe4938255a8a-CF72.data.json";